/**
 * The landing beacon (BOAT-1897).
 *
 * One beacon once the app has mounted, and then nothing until the session has
 * lapsed or the visitor does something worth recording — an add to cart, a
 * checkout, a signup, an order. There is deliberately no router hook: a page
 * view is not an arrival, and a beacon on every navigation is exactly the
 * thing that makes a visits table unusable and a conversion report unaffordable.
 *
 * This is the BOAT-1895 landing signal grown up rather than a second beacon
 * beside it. The visit endpoint takes the same device block, so the device is
 * still recorded on landing — it now arrives with the arrival it belongs to,
 * and with the attribution that came in on the URL.
 *
 * Client-only, which is also what keeps bots out: a crawler that does not run
 * JS never mints a visitor id, so it never becomes a visit. The API's
 * user-agent denylist catches the headless remainder, and records what it
 * caught rather than dropping it, so the exclusion can be measured.
 */
export default defineNuxtPlugin((nuxtApp) => {
  if (typeof window === 'undefined') return

  nuxtApp.hook('app:mounted', () => {
    const { recordLanding } = useVisit()

    // Fire and forget: nothing on the page is waiting for this.
    void recordLanding()
  })
})
